import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CustomModal from "../listings/Modal";
import { Avatar, Box, Button, Snackbar, Typography } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { connect } from "react-redux";

const headCellSx = {
  borderBottom: "1px solid #2a2a2a",
  color: "#777",
  fontSize: "12px",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  backgroundColor: "#1a1a1a",
  py: 1.5,
};

const rowSx = {
  cursor: "pointer",
  transition: "0.2s",
  "& td": { borderBottom: "1px solid #1e1e1e", color: "#ccc" },
  "&:hover": { backgroundColor: "#1f1f1f", "& td": { color: "#FFC001" } },
};

const ListingTableHeadings = ["", "Name"];

const BlockList = ({ data, jwtToken, fetchBlockedUser, handleUnblockUser }) => {
  const [openUnBlockModal, setOpenUnBlockModal] = useState(false);
  const [confirmProp, setConfirmProp] = useState(false);
  const [openSucessAlert, setOpenSucessAlert] = useState(false);
  const [userId, setUserId] = useState(null);

  const handleCloseUnBlockModal = () => {
    setOpenUnBlockModal(!openUnBlockModal);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSucessAlert(false);
  };

  useEffect(() => {
    if (confirmProp && userId) {
      handleUnblockUser(userId);
    }

    return () => {
      setConfirmProp(false);
    };
  }, [confirmProp, jwtToken, userId]);

  const handleUnBlock = (item) => {
    setUserId(item.id);
    setOpenUnBlockModal(true);
  };

  return (
    <>
      <Snackbar
        open={openSucessAlert}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <div>
          <MuiAlert onClose={handleClose} severity="success">
            User Unblocked Successfully!
          </MuiAlert>
        </div>
      </Snackbar>
      <CustomModal
        title="Unblock Alert"
        content={
          "Are you sure you want to un-block this user? This will restore all the conversations, related listings and neighbour stores."
        }
        openModal={openUnBlockModal}
        closeModal={handleCloseUnBlockModal}
        actionTitle={"Unblock"}
        setConfirmProp={setConfirmProp}
        actionColor={"red"}
      />
      <Box sx={{ backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "16px", overflow: "hidden" }}>
        {data && data.length > 0 ? (
          <Box sx={{ overflowX: "auto" }}>
            <Table sx={{ borderCollapse: "collapse" }}>
              <TableHead>
                <TableRow>
                  {ListingTableHeadings.map((item) => (
                    <TableCell key={item} align="left" sx={headCellSx}>
                      {item}
                    </TableCell>
                  ))}
                  <TableCell sx={headCellSx} />
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((item) => (
                  <TableRow key={item.id} sx={rowSx}>
                    <TableCell align="left" sx={{ width: 0, p: "8px 12px" }}>
                      <Avatar
                        alt={item.full_name}
                        src={item.avatar_url}
                        sx={{ width: 40, height: 40 }}
                      />
                    </TableCell>
                    <TableCell align="left" sx={{ fontSize: "13px" }}>
                      {item.full_name}
                    </TableCell>
                    <TableCell align="right">
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => handleUnBlock(item)}
                        sx={{
                          borderColor: "#ff4444",
                          color: "#ff4444",
                          fontSize: "12px",
                          fontWeight: 700,
                          textTransform: "none",
                          borderRadius: "8px",
                          "&:hover": { backgroundColor: "rgba(255,68,68,0.08)", borderColor: "#ff6666" },
                        }}
                      >
                        Unblock
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        ) : (
          <Box
            display="flex"
            alignItems="center"
            sx={{ py: 8 }}
            justifyContent="center"
            flexDirection="column"
          >
            <Typography sx={{ fontSize: "14px", color: "#555" }}>
              You haven't blocked any users.
            </Typography>
          </Box>
        )}
      </Box>
    </>
  );
};

const mapStateToProps = ({ Auth }) => ({
  jwtToken: Auth.jwtToken,
  user: Auth.user,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(BlockList);
